import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPrint, faCheck } from '@fortawesome/free-solid-svg-icons';
import { useScrollAnimation } from '../../helpers/useScrollAnimation';
import './Print.css';

const features = ['printFeature1', 'printFeature2', 'printFeature3', 'printFeature4'];

export const Print = () => {
    const { t } = useTranslation();
    const sectionRef = useScrollAnimation();

    return (
        <section id="print" className="section print-section" ref={sectionRef}>
            <div className="container">
                <div className="print-inner fade-up">
                    <div className="print-icon-wrap">
                        <FontAwesomeIcon icon={faPrint} />
                    </div>
                    <div className="print-content">
                        <span className="section-label">{t("printLabel")}</span>
                        <h2 className="section-title">{t("printTitle")}</h2>
                        <p className="print-desc">{t("printDesc")}</p>
                        <ul className="print-features">
                            {features.map((key) => (
                                <li key={key}>
                                    <span className="feature-check">
                                        <FontAwesomeIcon icon={faCheck} />
                                    </span>
                                    <span>{t(key)}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="print-visual">
                        <PrintVisual />
                    </div>
                </div>
            </div>
        </section>
    );
};

const PrintVisual = () => (
    <svg viewBox="0 0 220 200" fill="none" xmlns="http://www.w3.org/2000/svg" className="print-svg">
        <rect x="30" y="70" width="160" height="100" rx="5" fill="#3D2B1F" opacity="0.9"/>
        <rect x="45" y="82" width="130" height="76" rx="3" fill="#2C1A0E"/>
        <rect x="55" y="92" width="60" height="8" rx="2" fill="#E8A54C" opacity="0.9"/>
        <rect x="55" y="106" width="40" height="5" rx="1.5" fill="rgba(255,255,255,0.35)"/>
        <rect x="55" y="116" width="50" height="5" rx="1.5" fill="rgba(255,255,255,0.25)"/>
        <rect x="55" y="126" width="35" height="5" rx="1.5" fill="rgba(255,255,255,0.2)"/>
        <rect x="125" y="92" width="44" height="44" rx="4" fill="#B07030" opacity="0.3" stroke="#E8A54C" strokeWidth="1.5"/>
        <text x="138" y="120" fill="#E8A54C" fontSize="18" fontFamily="Montserrat" fontWeight="800" opacity="0.9">fb</text>
        <rect x="30" y="55" width="160" height="18" rx="4" fill="#B07030" opacity="0.25" stroke="#B07030" strokeWidth="1"/>
        <circle cx="50" cy="64" r="4" fill="#E8A54C" opacity="0.7"/>
        <circle cx="65" cy="64" r="4" fill="rgba(255,255,255,0.3)"/>
        <circle cx="80" cy="64" r="4" fill="rgba(255,255,255,0.3)"/>
        <rect x="50" y="170" width="120" height="12" rx="3" fill="#B07030" opacity="0.15" stroke="#B07030" strokeWidth="1"/>
        <line x1="50" y1="182" x2="170" y2="182" stroke="#B07030" strokeWidth="0.8" opacity="0.3"/>
        <path d="M30 170 L50 182" stroke="#B07030" strokeWidth="1" opacity="0.2"/>
        <path d="M190 170 L170 182" stroke="#B07030" strokeWidth="1" opacity="0.2"/>
    </svg>
);
